import { DEFAULT_TEXT_INPUT_MAX_LENGTH, DEFAULT_TEXT_INPUT_MIN_LENGTH } from '../../../constants/shared';
export const ADMINS_FORM = {
    'ADMIN.EMAIL': 'Adresă de e-mail',
    'ADMIN.FIRST_NAME': 'Prenume',
    'ADMIN.LAST_NAME': 'Nume',
    'ADMIN.VALIDATION.INSERT_EMAIL': 'Introduceţi adresa de e-mail a administratorului',
    'ADMIN.VALIDATION.INSERT_FIRST_NAME': 'Introduceţi prenumele administratorului',
    'ADMIN.VALIDATION.INSERT_LAST_NAME': 'Introduceţi numele administratorului',
    'ADMIN.VALIDATION.FIRST_NAME_IN_INTERVAL': `Prenumele administratorului trebuie să fie de minim ${DEFAULT_TEXT_INPUT_MIN_LENGTH}, maxim ${DEFAULT_TEXT_INPUT_MAX_LENGTH} caractere`,
    'ADMIN.VALIDATION.LAST_NAME_IN_INTERVAL': `Numele administratorului trebuie să fie de minim ${DEFAULT_TEXT_INPUT_MIN_LENGTH}, maxim ${DEFAULT_TEXT_INPUT_MAX_LENGTH} caractere`,
    'ADMIN.VALIDATION.EMAIL_IS_ALREADY_USED': 'Această adresă de e-mail este folosită de un alt utilizator'
};
